<template>
  <div class="card">
    <div class="card-body">
      <div class="mb-2" :class="$style.textDivider">
        <h4
          class="font-size-16 font-weight-bold"
          :class="$style.textDividerContent"
        >
          Documentação
        </h4>
      </div>

      <template v-if="loading">
        <div class="d-flex justify-content-center bd-highlight mb-3">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </template>
      <template v-else>
        <!-- Main table element -->

        <b-table
          show-empty
          stacked="sm"
          striped
          emptyText="Não existem documentos associados a este cliente"
          :items="displayItens"
          :fields="fields"
          :per-page="perPage"
          :filter="filter"
        >
          <template slot="name" slot-scope="row">
            {{ row.value.first }} {{ row.value.last }}
          </template>

          <template slot="isActive" slot-scope="row">
            {{ row.value ? "Yes :)" : "No :(" }}
          </template>

          <template v-slot:cell(open)="row">
            <b-button
              size="sm"
              target="_blank"
              :href="`${row.item.name.includes('http') ? '' : onboardFilesCnd }${row.item.name}`"
              ><i class="fe fe-eye"></i
            ></b-button>
          </template>

          <template v-slot:cell(remove)="row">
            <b-button
              size="sm"
              @click="
                removeFile(`${row.item.idMerchantFile}`, `${row.item.name}`)
              "
              ><i :v-if="!loading" class="fe fe-trash"></i>
              <b-spinner
                small
                variant="primary"
                label="Spinning"
                v-show="loading"
              ></b-spinner>
            </b-button>
          </template>

          <!-- <template v-slot:cell(actions)="row">
          <b-button size="sm" :href="`/merchant/file/${row.item.idMerchantFile}/edit`"
            ><i class="fe fe-trash"></i
          ></b-button>
        </template> -->

          <template slot="row-details" slot-scope="row">
            <b-card>
              <ul>
                <li v-for="(value, key) in row.item" :key="key">
                  {{ key }}: {{ value }}
                </li>
              </ul>
            </b-card>
          </template>
        </b-table>
      </template>
      <!-- <b-row>
        <b-col md="6" class="my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            @input="onChangePage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row> -->
      <!-- <b-modal ref="editar" hide-footer title="Editar Merchant" size="xl">
      <template v-slot:default="{ hide }">
        <formulario-equipamentos @hide="hide" :edicao="true" :dispositivo="dispositivoEditar" />
      </template>
    </b-modal> -->
    </div>
  </div>
</template>


<script>
// import FormularioEquipamentos from './formulario'
import { get as _get, debounce as _debounce } from "lodash";
import { Contants } from "@/utils/constants.js";
import { MerchantFilesResource } from "@/resources/MerchantFiles.resource.js";
export default {
  name: "ListMerchantFiles",
  //   components: {
  //     FormularioEquipamentos
  //   },

  props: {
    outdateParent: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },

  data() {
    return {
      loading: false,
      filtrosLocal: {
        idMerchant: _get(this.idMerchant, 0),
        index: 1,
        size: 20,
      },
      itens: [],
      displayItens: [],

      fields: [
        { key: "idMerchantFile", label: "Id" },
        { key: "name", label: "Nome" },
        { key: "merchantFileType", label: "Tipo" },
        { key: "dtCreated", label: "Data Cadastro" },

        { key: "open", label: "Abrir" },
        { key: "remove", label: "Remover" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      pageOptions: [25, 40, 60],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      onboardFilesCnd: Contants.OnboardingFilesUrl,
    };
  },

  watch: {
    outdateParent: function (newValue, oldValue) {
      if (newValue) {
        this.filtrar();
      }
    },
  },
  methods: {
    filtrar() {
      this.filtrosLocal.idMerchant =
        this.filtrosLocal.idMerchant == 0 ? null : this.filtrosLocal.idMerchant;
      this.itens = [];
      this.displayItens = [];
      this.currentPage = 1;
      this.getListMerchantFiles();
    },

    adicionar() {
      this.$refs["view"].show();
    },

    removeFile(id, name) {
      this.$bvModal
        .msgBoxConfirm("Voce deseja excluir o arquivo ?", {
          title: "Confirmação",
          size: "md",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "SIM",
          cancelTitle: "Não",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.loading = true;
            var payload = {
              idMerchantFile: parseInt(id),
              fileName: name,
            };

            MerchantFilesResource.deleteMerchantFile(payload)
              .then((result) => {
                this.loading = false;
                this.filtrar();
                this.$notification["success"]({
                  message: "Arquivo excluído",
                  description: "",
                });
              })
              .catch((e) => {
                this.loading = false;
                this.$notification["error"]({
                  message: "Ocorreu um erro",
                  description: "",
                });
              });
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },

    // lista de todos os dispositivos cadastrados
    getListMerchantFiles() {
      if (typeof this.itens[this.filtrosLocal.index] === "undefined") {
        // nessa situacao, precisamos buscar os dados, pois ainda nao forma consultados...
        this.loading = true;

        MerchantFilesResource.getList(this.filtrosLocal)
          .then((result) => {
            try {
              this.itens[this.filtrosLocal.index] = result.data.payload;
              this.displayItens = this.itens[this.filtrosLocal.index].flat();
              this.totalRows = 100; //result.data.payload.pageSettings.total;
              this.loading = false;
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason: "Deu ruim na chamada...",
                  },
                },
              };
            }
          })
          .catch((e) => {
            this.loading = false;
          });
      } else {
        // se já temos, apenas movesmo para a lista de exibicao...
        this.displayItens = this.itens[this.filtrosLocal.index].flat();
      }
    },

    onChangePage(a) {
      // uma mudanca do page filter ocorreu, vamos atualizar a lista...
      this.filtrosLocal.index = a;

      this.getListMerchantFiles();
    },

    limparFiltros() {
      this.filtrosLocal = {
        index: 1,
        size: 20,
        name: "",
      };
      this.filtrar();
    },
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    sysAdminUser() {
      try {
        return (
          this.$store.getters.user.role
            .split(",")
            .filter((role) => role === "SystemAdmin").length > 0
        );
      } catch (e) {
        return false;
      }
    },
  },
  mounted() {
    if (this.$route.params.id > 0) {
      this.idMerchant = this.$route.params.id;
      this.filtrosLocal.idMerchant = this.idMerchant;
      this.filtrar();
    }
  },
  created() {},
};
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
